import React, { useCallback, useRef, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { EASE } from './Reveal';
interface Sparkle {
  id: number;
  x: number;
  y: number;
}
interface AnimatedTitleProps {
  text: string;
  className?: string;
  /** Rastro de chispas doradas al pasar el cursor sobre el título. */
  sparkles?: boolean;
  as?: 'h1' | 'h2' | 'h3';
}
export function AnimatedTitle({
  text,
  className = '',
  sparkles = true,
  as = 'h2'
}: AnimatedTitleProps) {
  const reduce = useReducedMotion();
  const Tag = as;
  const [items, setItems] = useState<Sparkle[]>([]);
  const nextId = useRef(0);
  const lastAt = useRef(0);
  const handleMove = useCallback((event: React.MouseEvent<HTMLElement>) => {
    if (!sparkles || reduce) return;
    const now = Date.now();
    if (now - lastAt.current < 70) return;
    lastAt.current = now;
    const rect = event.currentTarget.getBoundingClientRect();
    const sparkle: Sparkle = {
      id: nextId.current++,
      x: event.clientX - rect.left + (Math.random() * 16 - 8),
      y: event.clientY - rect.top + (Math.random() * 16 - 8)
    };
    setItems(prev => [...prev.slice(-9), sparkle]);
    window.setTimeout(() => {
      setItems(prev => prev.filter(s => s.id !== sparkle.id));
    }, 600);
  }, [reduce, sparkles]);
  const words = text.split(' ');
  return <Tag onMouseMove={handleMove} className={`relative ${className}`} data-id="element-10" data-mp="5tew260f6zi2">
      {reduce ? text : <motion.span initial="hidden" whileInView="visible" viewport={{
      once: true,
      amount: 0.4
    }} transition={{
      staggerChildren: 0.028
    }} aria-hidden="true" className="inline" data-id="element-11" data-mp="10lq5et7tl4e">
          {words.map((word, wi) => <span key={`${word}-${wi}`} className="inline-block whitespace-nowrap" data-id="element-12" data-mp="3i90am3miqyq8" data-mpi={wi}>
              {Array.from(word).map((letter, li) => <motion.span key={`${letter}-${li}`} variants={{
          hidden: {
            opacity: 0,
            y: '0.32em'
          },
          visible: {
            opacity: 1,
            y: 0
          }
        }} transition={{
          duration: 0.28,
          ease: EASE
        }} className="inline-block" data-id="element-13" data-mp="3eb2lt1wnuend" data-mpi={li}>
                  {letter}
                </motion.span>)}
              {wi < words.length - 1 && <span className="inline-block" data-id="element-14" data-mp="3ncn65wg2af5h">&nbsp;</span>}
            </span>)}
        </motion.span>}
      {!reduce && <span className="sr-only" data-id="element-15" data-mp="3rce18ccmfhft">{text}</span>}

      <AnimatePresence data-id="element-16" data-mp="3dmam05c5snzv">
        {items.map(sparkle => <motion.span key={sparkle.id} initial={{
        opacity: 0.9,
        scale: 0.6,
        y: 0
      }} animate={{
        opacity: 0,
        scale: 1.4,
        y: -14
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.55,
        ease: 'easeOut'
      }} style={{
        left: sparkle.x,
        top: sparkle.y
      }} aria-hidden="true" className="pointer-events-none absolute h-1.5 w-1.5 rounded-full bg-[#E0A526] shadow-[0_0_10px_2px_rgba(224,165,38,0.8)]" data-id="element-17" data-mp="3djoeg5p9q8hn" />)}
      </AnimatePresence>
    </Tag>;
}